module.exports = __webpack_public_path__ + "static/media/YF60_1.3ae29f62.jpg";